export default function ContactDetails({ contact }) {
  return [contact.name, contact.email].filter(Boolean).join(' - ');
}
